import axios from "axios";
import config from "../../constants/config";

export async function getConfigData(token) {
    console.log('called getConfigData() method');
    return await axios.get(config.API_URL+"/admin/configData", {
      headers: {
        Authorization: token,
      },
    });
  }


  export async function postConfigData(token,configId,data) {
    console.log('called postConfigData() method');
    return await axios.put(config.API_URL+"/admin/configData", 
        {   
            id:configId,
           updateData:data
        },{
      headers: {
        Authorization: token,
      },
    });
  }


  export async function getTerms(page = 1, limit = 10, sortBy = 'publishDate', sortOrder = 'desc') {
    console.log('called getTerms() method');
    const token = sessionStorage.getItem("token");
    try {
        const response = await axios.get(config.API_URL + `/admin/terms?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`,{
          headers: {
            Authorization: token,
          },
        });
        return response.data; 
    } catch (error) {
        console.error("Error fetching terms:", error);

       
        throw error;
    }
}


export async function createTerm(termData) {
  console.log('called createTerm() method');
  const token = sessionStorage.getItem("token");
  try {
      const response = await axios.post(config.API_URL + "/admin/terms", termData, {
          headers: {
              Authorization: token,
          },
      });
      return response.data;
  } catch (error) {
      console.error("Error creating term:", error.response ? error.response.data : error);
      throw error;
  }
}
